/**
 * Site Refresh 2026: "Our Best Sellers" tabs (A5). WAI-ARIA tabs with automatic activation:
 * click, Left/Right arrows, Home and End switch the tab and show its panel.
 */
(() => {
	function select(tab, focus) {
		const list = tab.closest('[role="tablist"]');
		const root = tab.closest('[data-rbs]');
		if (!list || !root) return;
		list.querySelectorAll('[role="tab"]').forEach((t) => {
			const on = t === tab;
			t.setAttribute('aria-selected', on ? 'true' : 'false');
			t.tabIndex = on ? 0 : -1;
			const panel = root.querySelector('#' + CSS.escape(t.getAttribute('aria-controls')));
			if (panel) panel.hidden = !on;
		});
		if (focus) tab.focus();
		tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
	}

	document.addEventListener('click', (e) => {
		const tab = e.target.closest && e.target.closest('[data-rbs] [role="tab"]');
		if (tab) select(tab, false);
	});

	document.addEventListener('keydown', (e) => {
		const tab = e.target.closest && e.target.closest('[data-rbs] [role="tab"]');
		if (!tab) return;
		const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
		const i = tabs.indexOf(tab);
		let next = null;
		if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
		else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
		else if (e.key === 'Home') next = tabs[0];
		else if (e.key === 'End') next = tabs[tabs.length - 1];
		if (!next) return;
		e.preventDefault();
		select(next, true);
	});
})();
